<script setup lang="ts">
import { cx } from './cx'

type Tone = 'neutral' | 'accent' | 'ok' | 'warn' | 'danger' | 'info'

const TONES: Record<Tone, string> = {
  neutral: 'bg-raised text-muted border-line',
  accent: 'bg-accent/12 text-accent-dim border-accent/30',
  ok: 'bg-ok/10 text-ok border-ok/22',
  warn: 'bg-warn/10 text-warn border-warn/22',
  danger: 'bg-danger/10 text-danger border-danger/22',
  info: 'bg-link/10 text-link border-link/22',
}

withDefaults(defineProps<{ tone?: Tone }>(), { tone: 'neutral' })
</script>

<template>
  <span
    :class="
      cx(
        'inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[12px] font-medium leading-4 whitespace-nowrap',
        TONES[tone],
      )
    "
  >
    <slot />
  </span>
</template>
